import React from 'react';
import PropTypes from 'prop-types';
import RequestedStipsForm from './RequestedStipsForm';
import queryString from "query-string";
import {trackPageView} from '@forwardfinancing/analytics-frontend-library';

class StipsPage extends React.Component {
  componentDidMount() {
    trackPageView('Stips Page');
  }

  render() {
    const query = queryString.parse(this.props.location.search);
    const dba = decodeURIComponent(query.dba).replace("&amp;", "&");

    return (
      <div className="stips-page column page">
        <div className="stips-page__content column page">
          <div className="stips-page-dba-header">
            <h1 className="stips-page-dba-header__heading title is-4">Stipulations: {dba}</h1>
          </div>
          <RequestedStipsForm
            uuid={query.uuid}
            dba={dba}
          />
          <div className="stips-page-contact-bar">
            <p className="stips-page-contact-bar__content">
              If you have trouble uploading stipulations here, please email the files to
              <a href="mailto:closing@forwardfinancing.com"> closing@forwardfinancing.com</a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

StipsPage.propTypes = {
  location: PropTypes.object
};

export default StipsPage;
